/**
 * Strips the locale segment from a pathname (e.g. /en-nl/experiences -> /experiences).
 * The first path segment is treated as a locale when it matches the pattern xx or xx-yy (lowercase letters).
 */
function pathnameWithoutLocale(pathname: string): string {
  const trimmed = pathname.replace(/^\//, '').trim();
  const parts = trimmed ? trimmed.split('/') : [];
  const first = parts[0] ?? '';
  if (/^[a-z]{2}(-[a-z]{2})?$/.test(first)) {
    const rest = parts.slice(1);
    return rest.length > 0 ? `/${rest.join('/')}` : '/';
  }
  return pathname.startsWith('/') ? pathname : `/${pathname}`;
}

export default pathnameWithoutLocale;
